import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React from 'react';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { utcToZonedTime } from 'date-fns-tz';
import { formatISO } from 'date-fns';
import { Calendar } from 'primereact/calendar';

export const UserPage = () => {    

    const [todo, setTodo] = React.useState('');
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [businessTitle, setBusinessTitle] = React.useState('');
    const [username, setUsername] = React.useState('');
    const [isBlocked, setIsBlocked] = React.useState(false);
    const [isVerified, setIsVerified] = React.useState(false);
    const [birthDate, setBirthDate] = React.useState(null);
    const [submitted, setSubmitted]  = React.useState(false);
    const [isLoading, setIsLoading]  = React.useState(false);
    
    const businessTitleOption = [
        { name: 'Eduction', code: 'eduction' },
        { name: 'Sport', code: 'sport' },
        { name: 'Travel', code: 'travel' }
    ];

    const isBlockedOption = [
        {label: 'Ya', value: true},
        {label: 'Tidak', value: false}
    ];

    const isVerifiedOption = [
        {label: 'Terverifikasi', value: true},
        {label: 'Belum di Verifikasi', value: false}
    ];
    
    const toast = React.useRef();    
    const location = useLocation();
    let history = useHistory();

    React.useEffect(function() {
        setTodo(location.state.todo);
        if(location.state.todo === 'Ubah') {
            setName(location.state.dataUser.name);
            setEmail(location.state.dataUser.email);
            setPhone(location.state.dataUser.phone);
            setBusinessTitle(location.state.dataUser.businessTitle);
            setUsername(location.state.dataUser.username);
            setIsBlocked(location.state.dataUser.isBlocked);
            setIsVerified(location.state.dataUser.isVerified);
            setBirthDate(new Date(location.state.dataUser.birthDate));
        }        
    }, [location])

    const showSuccess = (msg) => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: msg, life: 3000 });
    };

    const showFailed = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: msg, life: 3000 });
    };

    const showError = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
    };

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);        
        if(!name || !email || !phone || !businessTitle || !username || isBlocked === null ? true:false || isVerified === null ? true:false || !birthDate)  {         
            showFailed('Form '+todo+' user tidak boleh ada yang kosong')               
        } else {
            const zonedDate = utcToZonedTime(birthDate, "Asia/Jakarta");
            const birthDateConverted = formatISO(zonedDate, { representation: "complete" });

            const requestPayload = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' ,
                    'Authorization': 'Bearer ' +localStorage.getItem('jwt')
                },
                body: JSON.stringify({                  
                    blocked: isBlocked,
                    businessTitle: businessTitle,
                    email: email,
                    name: name,
                    phone: phone,
                    username: username,
                    birthDate: birthDateConverted
                })
            }
            setIsLoading(true);
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/users/add-edit/'+todo, requestPayload);        
            const res = await response.json();
            console.log('response', res);
            if(response.status >= 200 && response.status <= 299) {                
                showSuccess(res.message);
                setTimeout(() => {
                    history.push('/users');
                }, 5000)
            } else if(response.status >= 400 && response.status <= 499) {
                showFailed(res.message);
            } else {
                showError(res.message);
            }
            setIsLoading(false);
        }
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">                    
                <Toast ref={toast} />
                    <h5>{todo} User</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="name">Name</label>
                            <InputText id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} className={classNames({ 'p-invalid': submitted && !name })} />
                            {submitted && !name && <small className="p-error">Enter your name</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="birthDate">Birth Date</label>
                            <Calendar showIcon monthNavigator yearNavigator yearRange="1990:2050" dateFormat="dd-mm-yy" value={birthDate} onChange={(e) => setBirthDate(e.value)}></Calendar>
                            {submitted && !birthDate && <small className="p-error">Enter your birth date</small>}
                        </div>                        
                        <div className="field">
                            <label htmlFor="email">Email</label>
                            <InputText id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} className={classNames({ 'p-invalid': submitted && !email })} />
                            {submitted && !email && <small className="p-error">Enter your email</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="phone">Phone</label>
                            <InputText id="phone" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} className={classNames({ 'p-invalid': submitted && !phone })} />
                            {submitted && !phone && <small className="p-error">Enter your phone</small>}
                        </div>
                        <div className="field">
                        <label htmlFor="businessTitle">Business Title</label>
                            <Dropdown id="businessTitle" value={businessTitle} onChange={(e) => setBusinessTitle(e.value)} options={businessTitleOption} optionLabel="name" optionValue="code" placeholder="Select One" className={classNames({ 'p-invalid': submitted && !businessTitle })}></Dropdown>
                            {submitted && !businessTitle && <small className="p-error">Enter your business title</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={classNames({ 'p-invalid': submitted && !username })} />
                            {submitted && !username && <small className="p-error">Enter your username</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="isBlocked">Blocked</label>                            
                            <Dropdown id="isBlocked" value={isBlocked} onChange={(e) => setIsBlocked(e.value)} options={isBlockedOption} optionLabel="label" optionValue="value" placeholder="Select One" className={classNames({ 'p-invalid': submitted && isBlocked === null ? true:false })}></Dropdown>
                            {submitted && isBlocked === null ? true:false && <small className="p-error">Enter your blocked</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="isVerified">Verified</label>                            
                            <Dropdown id="isVerified" value={isVerified} onChange={(e) => setIsVerified(e.value)} options={isVerifiedOption} optionLabel="label" optionValue="value" placeholder="Select One" className={classNames({ 'p-invalid': submitted && isVerified === null ? true:false })}></Dropdown>
                            {submitted && isVerified === null ? true:false && <small className="p-error">Enter your Verified</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" loading={isLoading} />
                    </form>
                </div>  
            </div>
        </div>
    );
}
